import React, {useState, useEffect, useContext} from 'react';
import { getItem } from '_services/agent';
import util from '../../common/util.js'
import {MapContext} from '_context/MapContext';
import {ollehModule} from '../../common/mapAPIExport'

let idleEvent = true
let markerArr = []
let resultPois = null
let guidVal = null
let markerImgUrl = null
let currentThemaCode = null

const RightGnb = (props) => {
    const [cadastralLayer, setCadastralLayer] = useState(null);
    const [contourLayer, setContourLayer] = useState(null);
    const [ic1ClassName, setIc1ClassName] = useState('')
    const [ic2ClassName, setIc2ClassName] = useState('')
    const [ic3ClassName, setIc3ClassName] = useState('')
    const [ic4ClassName, setIc4ClassName] = useState('')
    const [ic5ClassName, setIc5ClassName] = useState('')
    const [measureClassName, setMeasureClassName] = useState('hasSubmenu')
    const [themaClassName, setThemaClassName] = useState('hasSubmenu')
    const [drawClassName, setDrawClassName] = useState('hasSubmenu')
    const [themaCode, setThemaCode] = useState(null)
    const [wrapGnb, setWrapGnb] = useState('wrapGnb')
    const {ktMapIns} = useContext(MapContext);

    
    const [clusterer, setClusterer] = useState(
        new ollehModule.maps.overlay.MarkerClusterer({
            gap: 1, displayArea: false, minZoom: 0, maxZoom: 13, 
            clusterOpts: {
                iconFn: function (size) {
                    this.setDisplaySize(true);
                    var iconInfo = ollehModule.maps.overlay.MarkerCluster.DEFAULT_ICON_FN(size);
                    iconInfo.origin = new ollehModule.maps.Point(51 * (4 - Math.min(Math.floor(size / 20), 4)), -3);
                    return iconInfo;
                },
                clickToExpand:true,
                displayArea: true
            },
            afterCluster: function (cluster) {
                cluster.onEvent('click', function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    clusterInfoWindowShow(cluster) //cluster.getAllMarkers()
                });
            }
        })
    );
    
    useEffect(() => {
        if(ktMapIns){
            ktMapIns.onEvent('idle', function() {
                if(idleEvent){
                    themaSearch(0)
                    props.idleEnd()
                }               
            });
            setCadastralLayer(new ollehModule.maps.layer.OllehTileLayer({
                name: 'OllehCadastral', label: '지적편집도',  minZoom: 3, maxZoom: 13, autoActivate: true,
                tileURLTmpl: 'http://map.ktgis.com/CadastralMap/cadastral8.09.1_0928/layers/_alllayers/l#{z}/r#{y}/c#{x}.png'
            }))
            setContourLayer(new ollehModule.maps.layer.OllehTileLayer({
                name: 'OllehContourMap', label: '지형도', minZoom: 0, maxZoom: 13, autoActivate: true,
                tileURLTmpl: 'http://map.ktgis.com/HybridMap/3d130924/layers/_alllayers/l#{z}/r#{y}/c#{x}.png'
            }))
        }
    }, [ktMapIns]);

    useEffect(() => {
        currentThemaCode = themaCode
        if(themaCode){
            themaSearch(0)
        }else{
            mapClear()
        }
    }, [themaCode]);

    useEffect(() => {
        idleEvent = props.idleEventFire
    }, [props.idleEventFire]);

    const serviceOnOff = (type, service, notOn=false) => {
        let fun = eval('setIc'+type.substring(2)+'ClassName')
        if(eval(type + "ClassName != 'on'")){
            if(!notOn){
                fun('on')
            }
            service.activate()
        }else{
            fun('')
            service.deactivate()
        }
    }

    const layerOnOff = (type, layer) => {
        let fun = eval('setIc'+type.substring(2)+'ClassName')
        if(eval(type + "ClassName != 'on'")){
            fun('on')
            layer.setMap(ktMapIns)
        }else{
            fun('')
            layer.setMap(null)
        }
    }

    const menuClose = () => {
        setMeasureClassName('hasSubmenu'); setThemaClassName('hasSubmenu'); setDrawClassName('hasSubmenu');
    }

    const themaOnOff = (code, imgUrl) => {
        if(code === themaCode){
            setThemaCode(null)
            markerImgUrl = null
        }else{
            setThemaCode(code)
            markerImgUrl = imgUrl
            if(ktMapIns.getZoom()<11){
                ktMapIns.setZoom(11)
            }
        }
    }

    const themaSearch = (start)=>{
        mapClear();
        if(!currentThemaCode){
            return;
        }
        if(ktMapIns.getZoom()<11){
            if(currentThemaCode){
                warnMsgShow();
            }
            return;
        }
        if(start===0){
            resultPois = [];
            guidVal = util.guid()
        }
        //let point = ollehModule.maps.LatLng.valueOf(ktMapIns.getCenter());
        let lefBottom = ollehModule.maps.LatLng.valueOf(ktMapIns.getBounds().leftBottom);
        let rightTop = ollehModule.maps.LatLng.valueOf(ktMapIns.getBounds().rightTop);
        let param = '?numberOfResults=50&mode=NAVIGATION&start='+start+"&guid="+guidVal;
        let data = {"theme":{"code":[currentThemaCode]}, "bound":{"left":lefBottom.x, "bottom":lefBottom.y, "right":rightTop.x, "top":rightTop.y}}

        getItem('poi', param, data).then(res => {
            let remberGuidVal = res.config.url.split('guid=')[1];
            if(remberGuidVal===guidVal){
                let result = res.data
                resultPois = resultPois.concat(result.pois);
                if(result.numberOfPois>50 && result.numberOfPois>start && result.pois.length==50 && start<49 && ktMapIns.getZoom()!=13){
                    start += 50;
                    themaSearch(start);
                }else{
                    themaMapDisplay();
                }
            }
        }).catch(err => {});
    }

    const themaMapDisplay = ()=>{
        clusterer.setMap(null);
        resultPois.forEach((element, idx) => {
            var latLngPoint = new ollehModule.maps.LatLng(element.point.lat, element.point.lng);
            var point = ollehModule.maps.UTMK.valueOf(latLngPoint)
            var marker = new ollehModule.maps.overlay.Marker({
                position: point,
                icon:{url:markerImgUrl, size: new ollehModule.maps.Size(22, 22)},
            });
            marker['attribute'] = element
            marker.onEvent('click', function(e) {
                infoWindowShow(marker);
            });
            markerArr.push(marker);
            clusterer.add(marker);
        });
        clusterer.setMap(ktMapIns);
    }

    const infoWindowShow = (marker)=>{
        props.infoWindow(marker, true)
    }

    const clusterInfoWindowShow = (clusterMaker)=>{
        props.clusterInfoWindow(clusterMaker, true)
    }

    const mapClear = ()=>{
        clusterer.clear();
        markerArr = [];
    }

    const warnMsgShow = ()=>{
        //alert('현재의 지도 배율에서는 테마정보를 볼 수 없습니다.')
    }

    return (
        <div>
            <div className={wrapGnb} style={{zIndex:99}}>
                <ul>
                    <li onClick={(e) => serviceOnOff('ic1', ktMapIns.services.customTrafficInfo)}>
                        <button title="교통정보" className={ic1ClassName}>
                            <span className="btnsGnb ic1"></span><span className="txt">교통정보</span>
                        </button>
                    </li>
                    <li onClick={(e) => layerOnOff('ic2', cadastralLayer)}>
                        <button title="지적편집도" className={ic2ClassName}>
                            <span className="btnsGnb ic2"></span><span className="txt">지적편집도</span>
                        </button>
                    </li>
                    <li onClick={(e) => layerOnOff('ic3', contourLayer)}>
                        <button title="지형도" className={ic3ClassName}>
                            <span className="btnsGnb ic3"></span><span className="txt">지형도</span>
                        </button>
                    </li>
                    <li onClick={(e) => {menuClose(); measureClassName=='hasSubmenu'?setMeasureClassName('hasSubmenu open'):setMeasureClassName('hasSubmenu')}} className={measureClassName}>
                        <button title="거리재기">
                            <span className="btnsGnb ic4"></span><span className="txt">거리재기</span>
                        </button>
                        <div className="sub">
                            <button onClick={(e) => ktMapIns.services.measureService.clear()}>
                                <span className="btnsGnb ic6"></span><span className="txt">초기화</span>
                            </button>
                            <button className={ic5ClassName} onClick={(e) => serviceOnOff('ic5', ktMapIns.services.measureArea, true)}>
                                <span className="btnsGnb ic5"></span><span className="txt">면적재기</span>
                            </button>
                            <button className={ic4ClassName} onClick={(e) => serviceOnOff('ic4', ktMapIns.services.measureDistance,true)}>
                                <span className="btnsGnb ic4"></span><span className="txt">거리재기</span>
                            </button>
                        </div>
                    </li>
                    <li onClick={(e) => {menuClose(); themaClassName=='hasSubmenu'?setThemaClassName('hasSubmenu open'):setThemaClassName('hasSubmenu')}} className={themaClassName}>
                        <button title="주변테마"><span className="btnsGnb theme0">
                            </span><span className="txt">주변테마</span>
                        </button>
                        <div className="sub ea4">
                            <button className={themaCode==='TM_001'?'on':''} onClick={(e) => themaOnOff('TM_001', 'thema/ico_oil.png')}>
                                <span className="btnsGnb theme1"></span><span className="txt">주유소</span>
                            </button>
                            <button className={themaCode==='TM_002'?'on':''} onClick={(e) => themaOnOff('TM_002', 'thema/ico_lpg.png')}> 
                                <span className="btnsGnb theme2"></span><span className="txt">LPG</span>
                            </button>
                            <button className={themaCode==='TM_003'?'on':''} onClick={(e) => themaOnOff('TM_003', 'thema/ico_parking.png')}> 
                                <span className="btnsGnb theme3"></span><span className="txt">주차장</span>
                            </button>
                            <button className={themaCode==='TM_006'?'on':''} onClick={(e) => themaOnOff('TM_006', 'thema/ico_hotel.png')}> 
                                <span className="btnsGnb theme4"></span><span className="txt">숙박</span>
                            </button>
                            <button className={themaCode==='TM_007'?'on':''} onClick={(e) => themaOnOff('TM_007', 'thema/ico_bank.png')}> 
                                <span className="btnsGnb theme5"></span><span className="txt">은행/ATM</span>
                            </button>
                            <button className={themaCode==='TM_008'?'on':''} onClick={(e) => themaOnOff('TM_008', 'thema/ico_mart.png')}> 
                                <span className="btnsGnb theme6"></span><span className="txt">대형마트</span>
                            </button>
                            <button className={themaCode==='TM_010'?'on':''} onClick={(e) => themaOnOff('TM_010', 'thema/ico_hospital.png')}> 
                                <span className="btnsGnb theme7"></span><span className="txt">병원</span>
                            </button>
                            <button className={themaCode==='TM_011'?'on':''} onClick={(e) => themaOnOff('TM_011', 'thema/ico_pham.png')}> 
                                <span className="btnsGnb theme8"></span><span className="txt">약국</span>
                            </button>
                            <button className={themaCode==='TM_012'?'on':''} onClick={(e) => themaOnOff('TM_012', 'thema/ico_toilet.png')}> 
                                <span className="btnsGnb theme9"></span><span className="txt">화장실</span>
                            </button>
                            <button className={themaCode==='TM_004'?'on':''} onClick={(e) => themaOnOff('TM_004', 'thema/ico_clean.png')}> 
                                <span className="btnsGnb theme10"></span><span className="txt">세차장</span>
                            </button>
                            <button className={themaCode==='TM_005'?'on':''} onClick={(e) => themaOnOff('TM_005', 'thema/ico_restaurant.png')}> 
                                <span className="btnsGnb theme11"></span><span className="txt">음식점</span>
                            </button>
                            <button className={themaCode==='TM_009'?'on':''} onClick={(e) => themaOnOff('TM_009', 'thema/ico_gro.png')}> 
                                <span className="btnsGnb theme12"></span><span className="txt">편의점</span>
                            </button>
                        </div>
                    </li>
                    <li onClick={(e) => {menuClose(); drawClassName=='hasSubmenu'?setDrawClassName('hasSubmenu open'):setDrawClassName('hasSubmenu')}} className={drawClassName}>
                        <button title="그림도구"><span className="btnsGnb ic7"></span><span className="txt">그림도구</span></button>
                        <div className="sub">
                            <button><span className="btnsGnb ic7_3"></span><span className="txt">포인트</span></button>
                            <button><span className="btnsGnb ic7_2"></span><span className="txt">선</span></button>
                            <button><span className="btnsGnb ic7"></span><span className="txt">도형</span></button>
                        </div>
                    </li>
                    <li><button title="인쇄"><span className="btnsGnb ic8"></span><span className="txt">인쇄</span></button></li>
                    <li><button title="신규장소"><span className="btnsGnb ic9"></span><span className="txt">신규장소</span></button></li>
                </ul>
                <button className="btnToggle" onClick={(e) => {setWrapGnb(wrapGnb=='wrapGnb'?'wrapGnb small':'wrapGnb')}}>열기/닫기</button>
            </div>
        </div>
    );
}

export default RightGnb;